import styles from "./SkillContent.module.css";
import { SkillItem } from "./SkillItem";
import { MdKeyboardArrowDown } from "react-icons/md";

export const SkillContent = ({
  skill,
  isActiveIndex,
  index,
  changeActiveIndex,
}) => {
  const { Icon, title, subtitle, content } = skill;

  return (
    <div>
      <button
        onClick={() => changeActiveIndex(index)}
        aria-label="toggle skills list"
        className={styles.header}
      >
        <Icon
          className={styles.icon}
          style={{ marginRight: "var(--mb-0-75)" }}
        />
        <div>
          <h3 className={styles.title}>{title}</h3>
          <span className={styles.subtitle}>{subtitle}</span>
        </div>

        <MdKeyboardArrowDown
          className={`${styles.icon} ${styles.arrowIcon} ${
            isActiveIndex ? styles.rotate : ""
          }`}
        />
      </button>
      <div
        className={`${styles["menu-items"]} ${
          isActiveIndex ? styles.open : styles.close
        } grid`}
      >
        {content.map((item, idx) => (
          <SkillItem key={idx} name={item.name} progress={item.progress} />
        ))}
      </div>
    </div>
  );
};
